(() => {
  const form=document.querySelector('.contact-form');
  if(!form)return;
  const button=form.querySelector('.contact-submit');
  const status=document.getElementById('contact-status');
  const controls=[...form.querySelectorAll('input')];
  let busy=false,complete=false;
  const endpoint='https://rozz-brown.vercel.app/api/contacts';
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    if(busy||complete||!form.reportValidity())return;
    const body={name:form.elements['entry.571067086'].value,phone:form.elements['entry.1408365197'].value,email:form.elements['entry.279482849'].value,website:form.elements.website.value,contactPurpose:form.dataset.contactPurpose||''};
    busy=true;button.disabled=true;button.textContent='Saving…';status.textContent='';form.setAttribute('aria-busy','true');
    controls.forEach(input=>input.disabled=true);
    try{
      const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:AbortSignal.timeout(22000)});
      const result=await response.json();
      if(!response.ok||result.ok!==true)throw new Error(result.error||'We couldn’t save your details. Please try again later.');
      complete=true;status.textContent='Thanks! Your feedback call request has been saved.';status.dataset.state='success';button.textContent='Request saved';
    }catch(error){
      status.textContent=error.name==='TimeoutError'||error instanceof TypeError?'We couldn’t confirm your request. Check your connection and try again later.':error.message;
      status.dataset.state='error';button.textContent=form.dataset.contactPurpose?'Request a feedback call':'Submit details';button.disabled=false;controls.forEach(input=>input.disabled=false);
    }finally{busy=false;form.removeAttribute('aria-busy');}
  });
  button.type='submit';button.disabled=false;
})();
